import _ from 'lodash';
// eslint-disable-next-line import/no-relative-packages
import { CpCoverablesService } from '../../../capabilities/twia-capability-quoteandbind-cp';

const removeLocation = (async (loc, submissionVM, authHeader, setSelectedLocation) => {
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value')

    await CpCoverablesService.removeCPLocation(
        jobID,
        loc.value.publicID,
        submissionVM.sessionUUID.value,
        authHeader
    )

    _.remove(submissionVM.lobData.commercialProperty.coverables.locations.value,
        (currLocation) => currLocation.publicID === loc.value.publicID);

    if (setSelectedLocation) {
        setSelectedLocation(null);
    }
})

const removeUnwantedLocations = (async (publicIDs, submissionVM, authHeader, setSelectedLocation) => {
    const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value')

    await CpCoverablesService.removeCPUnwantedLocation(
        jobID,
        publicIDs,
        submissionVM.sessionUUID.value,
        authHeader
    )
    _.each(publicIDs,(publicID)=>{
        _.remove(submissionVM.lobData.commercialProperty.coverables.locations.value,
            (currLocation) => currLocation.publicID === publicID);
    })
    

    if (setSelectedLocation) {
        setSelectedLocation(null);
    }
})

const removeCPBuilding = (async (wizardData, setSelectedBuildingIndex, authHeader) => {
    const jobID = _.get(wizardData, 'quoteID.value') || _.get(wizardData, 'jobID.value')
    const locPublicID = wizardData.selectedLocation.publicID.value
    const buildingPublicID = wizardData.selectedBuilding.publicID
    const sessionID = wizardData.sessionUUID.value

    await CpCoverablesService.removeCPBuilding(jobID, locPublicID, buildingPublicID, sessionID, authHeader).then(() => {
        const locations = wizardData.lobData.commercialProperty.coverables.locations.value;
        const location = _.find(locations, (aLocation) => aLocation.publicID === wizardData.selectedLocation.value.publicID);

        _.remove(location.buildings,
            (currBuilding) => currBuilding.publicID === wizardData.selectedBuilding.publicID);

        if (setSelectedBuildingIndex) {
            setSelectedBuildingIndex(undefined);
        }
    });

})

export default {
    'removeLocation': removeLocation,
    'removeCPBuilding': removeCPBuilding,
    'removeUnwantedLocations' : removeUnwantedLocations
}